<div id="titulo">
    <h2>Gestión Petición</h2>
    <span style="flex: 1 1 auto;"></span>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</div>
<div style="padding: 20px;padding-bottom: 0;padding-top: 0.5em;">
    <h2 style="font-size: 17px;">Datos de cliente</h2>
    <div style="display: flex;gap: 10px;margin-top:20px; width:100%;">
        <div class="campo">
            <label>ID</label>
            <input matInput  [(ngModel)]="this.infoPeticion.id" readonly>
        </div>
        <div class="campo">
            <label>Fecha Pet.</label>
            <input matInput  [(ngModel)]="this.infoPeticion.fechaPet" readonly>
        </div>
        <div class="campo">
          <label>ID Reparación</label>
          <input matInput  [(ngModel)]="this.infoPeticion.reparacion" readonly>
        </div>
        <div class="campo">
          <label>Siniestro</label>
          <input matInput  [(ngModel)]="this.infoPeticion.siniestro" readonly >
        </div>
        <div class="campo">
          <label>Estado</label>
          <mat-select [(ngModel)]="this.infoPeticion.estado" (ngModelChange)="cambiarEstado($event)">
            <mat-option value="p">P-Pendiente</mat-option>
            <mat-option value="g">G-Gestionado</mat-option>
            <mat-option value="r">R-Rellamada</mat-option>
          </mat-select>
        </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:20px; width:99.7%;">
        <div class="campo">
          <label>Conductor</label>
          <input matInput  [(ngModel)]="this.infoPeticion.titular" readonly >
        </div>
        <div class="campo">
          <label>Teléfono</label>
          <input matInput  [(ngModel)]="this.infoPeticion.tel" readonly >
        </div>
        <div class="campo">
            <label>Compañia</label>
            <input matInput  [(ngModel)]="this.infoPeticion.cia" readonly >
        </div>
        <div class="campo">
            <label>Modalidad</label>
            <input matInput  [(ngModel)]="this.infoPeticion.modalidad" readonly >
        </div>
    </div>
    <h2 style="font-size: 17px">Datos Servicios</h2>
    <div style="display: flex;gap: 10px;margin-top:20px; width:99.7%;">
        <div class="campo">
            <label>Taller</label>
            <input matInput  [(ngModel)]="this.infoPeticion.taller" readonly >
        </div>
        <div class="campo">
            <label>Elem. Afectado</label>
            <input matInput  [title]="this.infoPeticion.afectado" [(ngModel)]="this.infoPeticion.afectado" readonly >
        </div>
        <div class="campo">
            <label>Tipo Serv.</label>
            <input matInput  [title]="this.infoPeticion.tipoServicio" [(ngModel)]="this.infoPeticion.tipoServicio" readonly >
        </div>
      <div class="campo">
        <label>Matrícula</label>
        <input matInput  [(ngModel)]="this.infoPeticion.matricula" readonly >
      </div>
      <div class="campo">
        <label>Marca</label>
        <input matInput  [title]="this.infoPeticion.marca" [(ngModel)]="this.infoPeticion.marca" readonly >
      </div>
      <div class="campo">
        <label>Modelo</label>
        <input matInput  [title]="this.infoPeticion.modelo" [(ngModel)]="this.infoPeticion.modelo" readonly >
      </div>
      <div class="campo">
        <label>Versión Vehículo</label>
        <input matInput  [title]="this.infoPeticion.v_veh" [(ngModel)]="this.infoPeticion.v_veh" readonly >
      </div>
      <div class="campo">
        <label>Vehículo Sust.</label>
        <input matInput  [(ngModel)]="this.infoPeticion.v_sus" readonly >
      </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:20px; width:99.7%;">
        <div class="campo" style="width: 80%">
          <label>Desc. Daños mecánicos</label>
          <input matInput  [(ngModel)]="this.infoPeticion.danos" readonly >
        </div>
        <div class="campo" style="width: 80%">
          <label>Observaciones</label>
          <input matInput  [(ngModel)]="this.infoPeticion.observaciones" readonly >
        </div>
    </div>
</div>
<div id="tablaContainer" *ngIf="comentarios.length>0" >
    <div style="position: absolute; right: 9px; top: 492px; z-index: 100;">
      <button mat-icon-button color="primary" (click)="abrirGrande()">
        <img src="assets/icons/fullscreen.svg" style="color: #093a33 !important;">
      </button>
    </div>
    <table mat-table [dataSource]="comentarioSource" class="tabla-art" style="min-width: auto; letter-spacing: 0;">
        <ng-container matColumnDef="linea">
            <th mat-header-cell *matHeaderCellDef>Linea</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.linea }}</td>
        </ng-container>
        <ng-container matColumnDef="fechaHora">
            <th mat-header-cell *matHeaderCellDef>Fecha/Hora</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.created }}</td>
        </ng-container>
        <ng-container matColumnDef="comentario">
            <th mat-header-cell *matHeaderCellDef>Comentario</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.obser }}</td>
        </ng-container>
        <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.usuario }}</td>
        </ng-container>
      <!-- Render columns -->
        <tr mat-header-row *matHeaderRowDef="['linea', 'fechaHora', 'comentario', 'usuario']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['linea', 'fechaHora', 'comentario', 'usuario']"></tr>
    </table>
</div>
<mat-progress-bar *ngIf="mostrarCarga" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions align="center" style="padding: 20px;">
    <a style="width: 15%;" class="btnCCOscuro" mat-flat-button (click)="agregarComentario()" >Nueva línea</a>
    <a style="width: 15%;" class="btnCCNewOscuro" mat-flat-button (click)="generarHoja()">Generar hoja</a>
</mat-dialog-actions>
